import { useAppDispatch, useAppSelector } from '@/shared/lib/redux'
import { fetchFoundations, selectFoundations, selectFoundationsLoading } from '../../model'
import { useFoundationAccrualModal } from '@/features/foundation-accrual'
import AccrualSvg from '@/shared/assets/images/Coins.svg'
import { NoTableData } from '@/shared/ui/no-table-data'
import { Loader } from '@/shared/ui/loader'
import { fromNanoToUnit } from '@/entities/bonus'
import { selectCommunityInfo } from '@/entities/community'

export const FoundationList = () => {
    const foundations = useAppSelector(selectFoundations)
    const community = useAppSelector(selectCommunityInfo)
    const { openFoundationAccrualModal } = useFoundationAccrualModal()
    const dispatch = useAppDispatch()
    const isLoading = useAppSelector(selectFoundationsLoading)
    const visibleFoundations = foundations.filter((foundation) => foundation.bot_id !== community.bot_id)
    
    const onAccrual = () => {
        dispatch(fetchFoundations())
    }

    return (
        <>
            {Boolean(visibleFoundations.length) &&
                <div className="grid grid-cols-12 gap-4">
                    {visibleFoundations.map((foundation) => (
                        <div key={foundation.id} className="col-span-12 screen:col-span-6 xxl:col-span-4">
                            <div className="box h-full min-h-[260px] flex flex-col justify-between hover:bg-gray-50 transition">
                                <div className="flex flex-col h-full">
                                    <div className="flex items-start gap-3">
                                        {foundation.logo ? (
                                            <div className="w-14 h-14 rounded-xl overflow-hidden shrink-0 border bg-white">
                                                <img src={foundation.logo} className="w-full h-full object-contain" alt="" />
                                            </div>
                                        ) : (
                                            <div className="w-14 h-14 rounded-xl shrink-0 border bg-gray-100 flex items-center justify-center text-gray-400 text-2xl font-bold">
                                                {foundation.name?.[0] ?? '?'}
                                            </div>
                                        )}
                                        <div className="flex-1 min-w-0">
                                            <div className="font-semibold text-base leading-tight text-color-dark line-clamp-2">
                                                {foundation.name}
                                            </div>
                                            <div className="flex items-center gap-2 mt-2">
                                                <span className="text-xs font-semibold uppercase px-2 py-0.5 rounded-full bg-color-primary/10 text-color-primary">
                                                    Фонд
                                                </span>
                                                <span className="text-xs text-gray-400">
                                                    {foundation.total_users} уч.
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="text-sm text-gray-500 mt-4 line-clamp-5 break-words">
                                        {foundation.description}
                                    </div>
                                </div>
                                <div className="flex items-center justify-between gap-3 pt-4 mt-4 border-t border-gray-100">
                                    <div>
                                        <div className="text-xs uppercase font-semibold text-gray-400">
                                            Баланс
                                        </div>
                                        <div className="font-semibold text-color-dark leading-tight">
                                            {fromNanoToUnit(foundation.total_wallet_balance)} ₽
                                        </div>
                                    </div>
                                    <button
                                        className="form_handle_button !w-auto px-4 h-10 shrink-0 flex items-center gap-2"
                                        onClick={() => openFoundationAccrualModal(onAccrual, {
                                            id: foundation.id,
                                            name: foundation.name
                                        })}
                                    >
                                        <AccrualSvg width={20} height={20} />
                                        Пожертвовать
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            }
            {(!Boolean(foundations.length) && isLoading) &&
                <div className="info_panel">
                    <Loader />
                </div>
            }
            {(!Boolean(visibleFoundations.length) && !isLoading) &&
                <NoTableData label='Нет данных о благотворительных фондах'/>
            }
        </>
    )
}
